import { render } from "./AddVan.vue?vue&type=template&id=2cb732ca"
import script from "./AddVan.vue?vue&type=script&lang=js"
export * from "./AddVan.vue?vue&type=script&lang=js"

import "./AddVan.vue?vue&type=style&index=0&id=2cb732ca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__